import { Checkbox } from "@material-ui/core";
import React from "react";

interface IProps {
  pmids: string[];
  verbose: boolean;
  ids: string[];
  setIds: (ids: string[]) => void;
  color?: "primary" | "secondary" | "default";
}

const AllCheckBox: React.FC<IProps> = ({
  pmids,
  verbose,
  ids,
  setIds,
  color = "primary",
}) => {
  const checked =
    pmids?.length > 0 && pmids?.every((pmid) => ids.includes(pmid));

  const setAllChecked = () => setIds([...new Set([...ids, ...pmids])]);

  const setAllUnChecked = () => setIds(ids.filter((id) => !pmids.includes(id)));

  const handleToggle = (e, checked: boolean) => {
    if (checked) {
      setAllChecked();
    } else {
      setAllUnChecked();
    }
  };
  return (
    <>
      {verbose && (
        <div>
          <Checkbox color={color} checked={checked} onChange={handleToggle} />
        </div>
      )}
    </>
  );
};

export default AllCheckBox;
